var Form = function () {

	var labelToogle = function () {

		function toggleFilledClass(el) {
			var textLength = el.val().length;
			if (textLength) {
				el.addClass('is-filled').removeClass('is-empty');
			} else {
				el.removeClass('is-filled').addClass('is-empty');
			}
		}

		$('.js-input-toggle').each(function(){
			toggleFilledClass($(this));
		});

		$('.js-input-toggle').keyup(function () {
			toggleFilledClass($(this));
		});

		$('.js-input-toggle').change(function () {
			toggleFilledClass($(this));
		});

	};

	var areaAutosize = function () {
		var $area = $('.js-area-autosize');

		if ($area.length) {
			UL.getScript('https://cdnjs.cloudflare.com/ajax/libs/autosize.js/3.0.20/autosize.min.js', function () {
				autosize($area);
			});
		}
	};

	var fileInputUi = function () {
		$('.js-file-input input').change(function () {
			var fileName = $(this).val().split('\\').pop();
			$(this).next('.js-file-value').text(fileName);
		});
	};

	var showPassword = function () {
		var inputClass = '.js-show-input';
		var $input;

		$('.js-show-password').on('mousedown touchstart', function(e){
			$input = $(this).siblings(inputClass);
			$input.attr('type', 'text');
			e.preventDefault();
		}).on('mouseup touchend', function(){
			var valLength = $input.val().length;
			$input.attr('type', 'password');
			$input.get(0).selectionStart = valLength;
			$input.get(0).selectionEnd = valLength;
			$input.focus();
		});
	};

	var registerCheck = function () {
		var registerForm = $('form[name="user_register"]');

		registerForm.on('submit', function (e) {
			var isPersonalDataAgreementChecked = $('#user_register_personalDataAgreement').is(':checked');

			var message = $('#formRegisterCheckMessage');

			if (!isPersonalDataAgreementChecked) {
				e.preventDefault();
				message.removeClass('hidden');
			} else {
				message.addClass('hidden');
			}
		});
	};

	var clearError = function () {
		var $weeklyTopicForm = $('form[name="weeklyTopic"]');

		$weeklyTopicForm.find('input, textarea')
			.keyup(function(){
				if ($(this).val()) {
					$(this).parent().removeClass('is-error');
					$(this).parent().find('ul.error-list').remove();
					$(this).parent().find('.m-input2__note').removeClass('hidden');
				}
			});

		$weeklyTopicForm.find(':checkbox')
			.change(function(){
				var $divWraper = $(this).parent().parent();
				var $errorList = $(this).parent().find('ul.error-list');

				if ($divWraper.hasClass('has-error')) {
					$divWraper.removeClass('has-error');
					$divWraper.addClass('had-error');
					$errorList.hide();
				} else if ($divWraper.hasClass('had-error')) {
					$divWraper.removeClass('had-error');
					$divWraper.addClass('has-error');
					$errorList.show();
				}
			})
	};

	var pushDataLayer = function (eventName) {
		dataLayer.push({
			'event': 'formInteraction',
			'actionType': 'Interakce s formulářem: Týden s lékařem',
			'fieldName': eventName
		})
	};

	var sendGAEvents = function () {
		var sentAlready = [];
		var $weeklyTopicForm = $('form[name="weeklyTopic"]');

		$weeklyTopicForm.find(':checkbox, #weeklyTopic_birthYear')
			.change(function(){
				var name = $(this).attr("name");
				var eventName = $(this).attr("data-ga-event-name");

				if ($.inArray(name, sentAlready) < 0) {
					pushDataLayer(eventName);
					sentAlready.push(name)
				}
			});

		$weeklyTopicForm.find(':text, textarea')
			.keyup(function(){
				var name = $(this).attr("name");
				var eventName = $(this).attr("data-ga-event-name");

				if ($.inArray(name, sentAlready) < 0) {
					pushDataLayer(eventName);
					sentAlready.push(name);
				}
			});

		$weeklyTopicForm.submit(function(){
			var eventName = $weeklyTopicForm.find(':submit').attr("data-ga-event-name");
			pushDataLayer(eventName);
		});
	};

	var init = function () {
		labelToogle();
		areaAutosize();
		fileInputUi();
		showPassword();
		registerCheck();
		clearError();
		sendGAEvents();
	};

	return {
		init: init
	};
}();

UL.register(Form);
